__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "cxc-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "18.2.13", () => (() => (__webpack_require__(6443))), 1);
			register("@angular/common", "18.2.13", () => (() => (__webpack_require__(316))), 1);
			register("@angular/core", "18.2.13", () => (() => (__webpack_require__(7404))), 1);
			register("@angular/router", "18.2.13", () => (() => (__webpack_require__(2392))), 1);
			register("@cxc/core/environment", "0.0.55", () => (() => (__webpack_require__(4691))), 1);
			register("@cxc/core/services", "0.0.55", () => (() => (__webpack_require__(4220))), 1);
			register("@ngneat/cashew", "4.1.0", () => (() => (__webpack_require__(5639))), 1);
			register("@primeng/themes", "18.0.2", () => (() => (__webpack_require__(6216))), 1);
			register("@primeuix/styled", "0.3.2", () => (() => (__webpack_require__(6096))), 1);
			register("@primeuix/utils", "0.3.2", () => (() => (__webpack_require__(4724))), 1);
			register("chart.js", "4.5.1", () => (() => (__webpack_require__(6792))), 1);
			register("chartjs-chart-geo", "4.3.4", () => (() => (__webpack_require__(2127))), 1);
			register("chartjs-chart-treemap", "3.1.0", () => (() => (__webpack_require__(5168))), 1);
			register("chartjs-plugin-stacked100", "1.7.0", () => (() => (__webpack_require__(4932))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};